import EligibilityCalculator from '../components/EligibilityCalculator';
import { defineCalculator } from './defineCalculator';

defineCalculator('scl-eligibility-calculator', EligibilityCalculator);
